import * as React from 'react';
import { Link } from 'react-router-dom';

import TextButton from '@/components/elements/Button/TextButton';
import Skeleton from '@/components/elements/Skeleton';
import SyllabarySelector from '@/components/layouts/Glossary/SyllabarySelector';
import { Term } from '@/lib/microcms/model';
import { htmlToThemed } from '@/lib/microcms/parseHTML';

import { Headline } from '../../style';
import { DISABLED_WORDS } from '..';
import { TermWrapper } from '../style';
import {
  ButtonWrapper,
  Container,
  Description,
  Hiragana,
  InfoWrapper,
  TermName,
} from './style';

interface TermInfoTemplateProps {
  term: Term | null;
  termName: string;
  initial: string;
}

const GlossaryInfoTemplate: React.FC<TermInfoTemplateProps> = ({
  term,
  termName,
  initial,
}) => {
  return (
    <Container>
      <Headline>競輪用語集</Headline>
      <InfoWrapper>
        <TermName>
          {termName}
          <Hiragana>
            {term?.hiragana || <Skeleton height="12px" width="150px" />}
          </Hiragana>
        </TermName>
        <Description>
          {term?.description ? (
            htmlToThemed(term.description)
          ) : (
            <Skeleton height="25px" count={3} style={{ lineHeight: 3 }} />
          )}
        </Description>
      </InfoWrapper>
      <ButtonWrapper>
        <Link to={`/glossary/${initial}`}>
          <TextButton size="s" hoverEffect="highlight">
            「{initial}」の用語一覧に戻る
          </TextButton>
        </Link>
      </ButtonWrapper>
      <TermWrapper>
        <SyllabarySelector
          disabledWords={DISABLED_WORDS}
          hasLink
          redirectTo={s => `/glossary/${s[0]}`}
        />
      </TermWrapper>
    </Container>
  );
};

export default GlossaryInfoTemplate;
